module.exports = __webpack_public_path__ + "img/brandon_villard.0f5d882e.png";